import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContractPartnerActions, ContractPartnerActionTypes } from '../../actions/mdqx/contract-partner.actions';
import { ContractPartnerEntity } from '../../../entities/mdqx/contract-partner.entity';

export interface ContractPartnerState extends EntityState<ContractPartnerEntity> {
    fetched: boolean;
}

export const CONTRACT_PARTNER_KEY = 'contractPartner';

const adapter = createEntityAdapter<ContractPartnerEntity>({
    selectId: contractPartner => contractPartner.Id,
});

const initialState: ContractPartnerState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractpartnerReducer(state = initialState, action: ContractPartnerActions) {
    switch (action.type) {
        case ContractPartnerActionTypes.GetResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case ContractPartnerActionTypes.PostResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case ContractPartnerActionTypes.DeleteResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContractPartners = selectAll;

export const selectContractPartnersFetched = (state: ContractPartnerState) => state.fetched;
